import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const redirectUrl = `${window.location.pathname}${window.location.search}`;
      window.location.href = `/login?showAlert=true&redirectUrl=${redirectUrl}`;
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("authUser"))?.token || null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
